import { useMemo, useState } from "react"
import { useSnackbar } from "../../core/contexts/SnackbarContext";
import { ApiFactory } from "../../core/config/ApiFactory";

export const useNotasFiscais = () => {
    const apiFinanceiro = useMemo(() => ApiFactory.getApi("MS_FINANCEIRO"), []);
    const [loading, setLoading] = useState(false);
    const snackbar = useSnackbar();

    const cancelar = async (uuid: string) => {
        try {
            setLoading(true);
            await apiFinanceiro.delete(`/contabilidade/nfce/${uuid}`);
            snackbar("Nota fiscal cancelada com sucesso");
        } catch (error) {
            snackbar("Ocorreu um erro ao cancelar a nota fiscal", { severity: 'error' })
        } finally {
            setLoading(false);
        }
    }

    return { cancelar, loading }
}